import type { CookieConsentApi } from '../types/cookie-consent'
import {
  consentStore,
  getCookieConsentController,
} from '../integrations/cookie-consent/consent-store'

/**
 * `montilla.cookieConsent.*` namespace.
 *
 * Imports ONLY the light consent-store module (controller holder + subscribers)
 * so adding this namespace to the montilla object costs nothing in the base
 * bundle. The banner itself is created lazily by the dynamically-imported
 * `integrations/cookie-consent/install` during `load()`. Until then (or in SSR,
 * or when `cookieConsent` isn't configured) every method is a safe no-op.
 */
export const cookieConsent: CookieConsentApi = {
  show() {
    getCookieConsentController()?.show()
  },
  hide() {
    getCookieConsentController()?.hide()
  },
  accept() {
    getCookieConsentController()?.accept()
  },
  hasConsent() {
    return getCookieConsentController()?.hasConsent() ?? false
  },
  getConsent() {
    return consentStore.get()
  },
  onChange(callback) {
    return consentStore.subscribe(callback)
  },
  reset() {
    getCookieConsentController()?.reset()
  },
}
